.container {
  width: 100%;
  height: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}

.headerBar {
  width: 100%;
  height: 50px;
  background-color: #007bff;
  margin-bottom: 20px;
}

.contentContainer {
  display: flex;
  flex-direction: column;
}

.footerBar {
  width: 100%;
  height: 50px;
  background-color: red;
}
